// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Página pública de descarga del agente CMDB (\`/instalar-agente\`).
 *
 * Prefijo \`ad-\` (Agent Download) para no colisionar con \`login.css\`, \`lists.css\`
 * ni los estilos de Bootstrap que se cargan globalmente. Solo se apoya en los
 * tokens del design system (colores, radios, tipografía).
 */

.ad-page {
  position: relative;
  min-height: 100vh;
  background: var(--slate-50, #07090f);
  color: var(--text-primary, #e2e8f0);
  font-family: var(--font-primary, 'Inter', sans-serif);
  padding: 0 0 40px;
  overflow-x: hidden;
}

.ad-glow {
  position: fixed;
  inset: 0;
  z-index: 0;
  pointer-events: none;
  background:
    radial-gradient(ellipse 70% 50% at 15% 0%, rgba(var(--accent-rgb, 99, 102, 241), .18) 0%, transparent 60%),
    radial-gradient(ellipse 60% 45% at 85% 10%, rgba(139, 92, 246, .12) 0%, transparent 60%);
}

.ad-wrap {
  position: relative;
  z-index: 1;
  max-width: 1080px;
  margin: 0 auto;
  padding: 0 20px;
}

/* ── Cabecera ─────────────────────────────────────────────────────────── */
.ad-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 18px 0;
}

.ad-brand {
  display: flex;
  align-items: center;
  gap: 10px;
}

.ad-brand-mark {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: 10px;
  color: #fff;
  background: linear-gradient(135deg, var(--accent, #6366f1), var(--accent-2, #7c3aed));
  box-shadow: 0 6px 18px rgba(var(--accent-rgb, 99, 102, 241), .35);
}

.ad-brand-name {
  font-size: 1rem;
  font-weight: 700;
  letter-spacing: .01em;
}

.ad-brand-name em {
  font-style: normal;
  color: var(--accent-l, #818cf8);
}

.ad-link {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  color: var(--text-secondary, rgba(255, 255, 255, .55));
  font-size: .85rem;
  text-decoration: none;
  transition: color .15s ease;
}

.ad-link:hover {
  color: var(--text-primary, #e2e8f0);
}

/* ── Hero ─────────────────────────────────────────────────────────────── */
.ad-hero {
  padding: 28px 0 8px;
}

.ad-h1 {
  margin: 0 0 10px;
  font-size: clamp(28px, 4vw, 42px);
  font-weight: 700;
  letter-spacing: -.02em;
}

.ad-sub {
  margin: 0;
  max-width: 720px;
  font-size: .98rem;
  line-height: 1.6;
  color: var(--text-secondary, rgba(255, 255, 255, .55));
}

.ad-sub strong {
  color: var(--text-primary, #e2e8f0);
}

.ad-hero-chips {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 16px;
}

.ad-alert {
  margin-top: 16px;
  padding: 10px 12px;
  border: 1px solid rgba(245, 158, 11, .35);
  border-radius: var(--radius-sm, 8px);
  background: var(--amber-50, rgba(245, 158, 11, .15));
  color: var(--text-primary, #e2e8f0);
  font-size: .85rem;
}

/* ── Secciones ────────────────────────────────────────────────────────── */
.ad-section {
  margin-top: 40px;
}

.ad-h2 {
  margin: 0 0 14px;
  font-size: 1.15rem;
  font-weight: 650;
  letter-spacing: -.01em;
}

.ad-h3 {
  margin: 20px 0 8px;
  font-size: .95rem;
  font-weight: 600;
}

.ad-p {
  margin: 0 0 10px;
  font-size: .88rem;
  line-height: 1.6;
  color: var(--text-secondary, rgba(255, 255, 255, .55));
}

.ad-p strong {
  color: var(--text-primary, #e2e8f0);
}

/* ── Listas y tablas de instrucciones ─────────────────────────────────── */
.ad-list {
  margin: 0 0 12px;
  padding-left: 20px;
  font-size: .88rem;
  line-height: 1.6;
  color: var(--text-secondary, rgba(255, 255, 255, .55));
}

.ad-list li {
  margin-bottom: 6px;
}

.ad-list li strong {
  color: var(--text-primary, #e2e8f0);
}

.ad-table {
  width: 100%;
  margin: 6px 0 16px;
  border-collapse: collapse;
  font-size: .82rem;
}

.ad-table th,
.ad-table td {
  padding: 8px 10px;
  border: 1px solid var(--border, rgba(255, 255, 255, .07));
  text-align: left;
  vertical-align: top;
}

.ad-table th {
  background: var(--bg-toolbar, rgba(255, 255, 255, .025));
  color: var(--text-primary, #e2e8f0);
  font-weight: 600;
}

.ad-table td {
  color: var(--text-secondary, rgba(255, 255, 255, .55));
}

.ad-table td:first-child {
  font-family: var(--font-mono, monospace);
  color: var(--accent-l, #818cf8);
  white-space: nowrap;
}

/* Desplegables (Orca, CLI…) */
.ad-details {
  margin: 10px 0;
  padding: 10px 12px;
  border: 1px solid var(--border, rgba(255, 255, 255, .07));
  border-radius: 10px;
  background: var(--bg-toolbar, rgba(255, 255, 255, .025));
}

.ad-details summary {
  cursor: pointer;
  font-size: .85rem;
  font-weight: 600;
  color: var(--text-primary, #e2e8f0);
}

.ad-details[open] summary {
  margin-bottom: 8px;
}

.ad-details .ad-list {
  margin-bottom: 0;
}

/* Generador de scripts (todo en el navegador) */
.ad-gen {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 12px;
  margin: 12px 0 14px;
}

.ad-field {
  display: flex;
  flex-direction: column;
  gap: 6px;
  font-size: .82rem;
  color: var(--text-secondary, rgba(255, 255, 255, .55));
}

.ad-field input,
.ad-field select {
  width: 100%;
  padding: 9px 10px;
  border: 1px solid var(--border, rgba(255, 255, 255, .07));
  border-radius: var(--radius-sm, 8px);
  background: var(--bg-input, rgba(255, 255, 255, .05));
  color: var(--text-primary, #e2e8f0);
  font-family: inherit;
  font-size: .85rem;
}

.ad-field input:focus,
.ad-field select:focus {
  outline: none;
  border-color: rgba(var(--accent-rgb, 99, 102, 241), .55);
  box-shadow: 0 0 0 3px rgba(var(--accent-rgb, 99, 102, 241), .15);
}

.ad-field .ad-hint {
  margin: 0;
}

.ad-gen-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-bottom: 14px;
}

.ad-gen-actions .ad-btn {
  margin-top: 0;
}

/* Aviso de credencial en el MST */
.ad-warn {
  margin-top: 14px;
  padding: 10px 12px;
  border: 1px solid rgba(245, 158, 11, .4);
  border-radius: 10px;
  background: var(--amber-50, rgba(245, 158, 11, .15));
  font-size: .82rem;
  line-height: 1.55;
  color: var(--text-primary, #e2e8f0);
}

.ad-warn strong {
  color: var(--amber-600, #f59e0b);
}

.ad-hint {
  margin: 8px 0 0;
  font-size: .76rem;
  line-height: 1.5;
  color: var(--text-muted, rgba(255, 255, 255, .35));
}

/* ── Rejillas y tarjetas ──────────────────────────────────────────────── */
.ad-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 16px;
}

.ad-grid--3 {
  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
}

.ad-card {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 18px;
  border: 1px solid var(--border, rgba(255, 255, 255, .07));
  border-radius: 14px;
  background: var(--bg-card, #0d0f1a);
  box-shadow: 0 10px 30px rgba(0, 0, 0, .25);
}

.ad-card--primary {
  border-color: rgba(var(--accent-rgb, 99, 102, 241), .45);
  box-shadow: 0 10px 34px rgba(var(--accent-rgb, 99, 102, 241), .18);
}

.ad-card-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}

.ad-card-title {
  margin: 0;
  font-size: 1rem;
  font-weight: 650;
}

.ad-card-sub {
  margin: 0;
  font-size: .8rem;
  color: var(--text-secondary, rgba(255, 255, 255, .55));
}

.ad-meta {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  font-size: .78rem;
  color: var(--text-secondary, rgba(255, 255, 255, .55));
}

.ad-filename {
  font-family: var(--font-mono, monospace);
  font-size: .78rem;
  color: var(--text-primary, #e2e8f0);
  overflow-wrap: anywhere;
}

.ad-note {
  margin: 0;
  font-size: .8rem;
  color: var(--text-secondary, rgba(255, 255, 255, .55));
}

.ad-hash {
  display: flex;
  flex-direction: column;
  gap: 2px;
  font-size: .7rem;
  color: var(--text-muted, rgba(255, 255, 255, .35));
}

.ad-hash code {
  font-family: var(--font-mono, monospace);
  font-size: .7rem;
  color: var(--text-secondary, rgba(255, 255, 255, .55));
  overflow-wrap: anywhere;
}

.ad-empty p {
  margin: 0 0 4px;
  font-size: .85rem;
  color: var(--text-secondary, rgba(255, 255, 255, .55));
}

/* ── Chips y botones ──────────────────────────────────────────────────── */
.ad-chip {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 3px 9px;
  border: 1px solid var(--border, rgba(255, 255, 255, .07));
  border-radius: 999px;
  background: var(--bg-toolbar, rgba(255, 255, 255, .025));
  font-size: .74rem;
  color: var(--text-secondary, rgba(255, 255, 255, .55));
  white-space: nowrap;
}

.ad-chip--accent {
  border-color: rgba(var(--accent-rgb, 99, 102, 241), .5);
  background: var(--blue-50, rgba(99, 102, 241, .15));
  color: var(--accent-l, #818cf8);
}

.ad-chip--on {
  border-color: rgba(16, 185, 129, .4);
  background: rgba(16, 185, 129, .12);
  color: var(--green-600, #10b981);
}

.ad-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin-top: 6px;
  padding: 10px 14px;
  border: 1px solid var(--border, rgba(255, 255, 255, .07));
  border-radius: var(--radius-sm, 8px);
  background: var(--bg-input, rgba(255, 255, 255, .05));
  color: var(--text-primary, #e2e8f0);
  font-size: .85rem;
  font-weight: 600;
  text-decoration: none;
  transition: border-color .15s ease, transform .15s ease, background .15s ease;
}

.ad-btn:hover {
  border-color: var(--slate-300, rgba(255, 255, 255, .14));
  transform: translateY(-1px);
  color: var(--text-primary, #e2e8f0);
}

.ad-btn--primary {
  border-color: transparent;
  background: linear-gradient(135deg, var(--accent, #6366f1), var(--accent-dark, #4f46e5));
  color: #fff;
  box-shadow: 0 8px 22px rgba(var(--accent-rgb, 99, 102, 241), .35);
}

.ad-btn--primary:hover {
  color: #fff;
  background: linear-gradient(135deg, var(--accent-l, #818cf8), var(--accent, #6366f1));
}

/* ── Pasos previos ────────────────────────────────────────────────────── */
.ad-step {
  position: relative;
  padding: 16px 16px 16px 18px;
  border: 1px solid var(--border, rgba(255, 255, 255, .07));
  border-radius: 12px;
  background: var(--bg-toolbar, rgba(255, 255, 255, .025));
}

.ad-step h3 {
  margin: 0 0 6px;
  font-size: .92rem;
  font-weight: 650;
}

.ad-step p {
  margin: 0;
  font-size: .84rem;
  line-height: 1.55;
  color: var(--text-secondary, rgba(255, 255, 255, .55));
}

.ad-step-num {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  margin-bottom: 8px;
  border-radius: 50%;
  background: var(--blue-50, rgba(99, 102, 241, .15));
  color: var(--accent-l, #818cf8);
  font-size: .78rem;
  font-weight: 700;
}

.ad-role {
  display: block;
  margin-top: 6px;
}

.ad-role code,
.ad-inline-code {
  padding: 1px 5px;
  border-radius: 4px;
  background: var(--bg-input, rgba(255, 255, 255, .05));
  font-family: var(--font-mono, monospace);
  font-size: .78rem;
  color: var(--accent-l, #818cf8);
  overflow-wrap: anywhere;
}

/* ── Pestañas de instalación ──────────────────────────────────────────── */
.ad-tabs {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  border-bottom: 1px solid var(--border, rgba(255, 255, 255, .07));
  margin-bottom: 16px;
}

.ad-tab {
  padding: 9px 14px;
  border: none;
  border-bottom: 2px solid transparent;
  background: transparent;
  color: var(--text-secondary, rgba(255, 255, 255, .55));
  font-size: .85rem;
  font-weight: 550;
  cursor: pointer;
  transition: color .15s ease, border-color .15s ease;
}

.ad-tab:hover {
  color: var(--text-primary, #e2e8f0);
}

.ad-tab.is-active {
  color: var(--accent-l, #818cf8);
  border-bottom-color: var(--accent, #6366f1);
}

.ad-panel {
  padding: 18px;
  border: 1px solid var(--border, rgba(255, 255, 255, .07));
  border-radius: 12px;
  background: var(--bg-card, #0d0f1a);
}

/* ── Bloques de código ────────────────────────────────────────────────── */
.ad-code-wrap {
  position: relative;
  margin: 10px 0 14px;
}

.ad-code {
  margin: 0;
  padding: 14px 14px;
  padding-right: 90px;
  border: 1px solid var(--border, rgba(255, 255, 255, .07));
  border-radius: 10px;
  background: #06070c;
  color: #d7dcf5;
  font-family: var(--font-mono, 'Consolas', monospace);
  font-size: .79rem;
  line-height: 1.6;
  overflow-x: auto;
  white-space: pre;
  tab-size: 2;
}

.ad-copy {
  position: absolute;
  top: 8px;
  right: 8px;
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 4px 8px;
  border: 1px solid var(--border, rgba(255, 255, 255, .07));
  border-radius: 6px;
  background: rgba(255, 255, 255, .04);
  color: var(--text-secondary, rgba(255, 255, 255, .55));
  font-size: .72rem;
  cursor: pointer;
}

.ad-copy:hover {
  color: var(--text-primary, #e2e8f0);
  border-color: var(--slate-300, rgba(255, 255, 255, .14));
}

/* ── Pie ──────────────────────────────────────────────────────────────── */
.ad-foot {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
  margin-top: 48px;
  padding-top: 18px;
  border-top: 1px solid var(--border, rgba(255, 255, 255, .07));
  font-size: .78rem;
  color: var(--text-muted, rgba(255, 255, 255, .35));
}

@media (max-width: 640px) {
  .ad-code {
    padding-right: 14px;
    padding-top: 40px;
  }

  .ad-copy {
    left: 8px;
    right: auto;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/agent-download.css"],"names":[],"mappings":"AAAA;;;;;;EAME;;AAEF;EACE,kBAAkB;EAClB,iBAAiB;EACjB,oCAAoC;EACpC,mCAAmC;EACnC,qDAAqD;EACrD,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,UAAU;EACV,oBAAoB;EACpB;;4FAE0F;AAC5F;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA,4EAA4E;AAC5E;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,WAAW;EACX,qFAAqF;EACrF,iEAAiE;AACnE;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,+BAA+B;AACjC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,sDAAsD;EACtD,iBAAiB;EACjB,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,mCAAmC;AACrC;;AAEA,4EAA4E;AAC5E;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,iCAAiC;EACjC,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,sDAAsD;AACxD;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,yCAAyC;EACzC,oCAAoC;EACpC,oDAAoD;EACpD,mCAAmC;EACnC,iBAAiB;AACnB;;AAEA,4EAA4E;AAC5E;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,sDAAsD;AACxD;;AAEA;EACE,mCAAmC;AACrC;;AAEA,4EAA4E;AAC5E;EACE,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,sDAAsD;AACxD;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;;EAEE,iBAAiB;EACjB,yDAAyD;EACzD,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,wDAAwD;EACxD,mCAAmC;EACnC,gBAAgB;AAClB;;AAEA;EACE,sDAAsD;AACxD;;AAEA;EACE,wCAAwC;EACxC,+BAA+B;EAC/B,mBAAmB;AACrB;;AAEA,8BAA8B;AAC9B;EACE,cAAc;EACd,kBAAkB;EAClB,yDAAyD;EACzD,mBAAmB;EACnB,wDAAwD;AAC1D;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,mCAAmC;AACrC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,gDAAgD;AAChD;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,iBAAiB;EACjB,sDAAsD;AACxD;;AAEA;;EAEE,WAAW;EACX,iBAAiB;EACjB,yDAAyD;EACzD,oCAAoC;EACpC,qDAAqD;EACrD,mCAAmC;EACnC,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;;EAEE,aAAa;EACb,wDAAwD;EACxD,gEAAgE;AAClE;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA,kCAAkC;AAClC;EACE,gBAAgB;EAChB,kBAAkB;EAClB,wCAAwC;EACxC,mBAAmB;EACnB,oDAAoD;EACpD,iBAAiB;EACjB,iBAAiB;EACjB,mCAAmC;AACrC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,kDAAkD;AACpD;;AAEA,4EAA4E;AAC5E;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,2DAA2D;AAC7D;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,aAAa;EACb,yDAAyD;EACzD,mBAAmB;EACnB,mCAAmC;EACnC,0CAA0C;AAC5C;;AAEA;EACE,wDAAwD;EACxD,kEAAkE;AACpE;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;AACV;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,sDAAsD;AACxD;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,sDAAsD;AACxD;;AAEA;EACE,wCAAwC;EACxC,iBAAiB;EACjB,mCAAmC;EACnC,uBAAuB;AACzB;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,sDAAsD;AACxD;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;EAChB,kDAAkD;AACpD;;AAEA;EACE,wCAAwC;EACxC,gBAAgB;EAChB,sDAAsD;EACtD,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,sDAAsD;AACxD;;AAEA,4EAA4E;AAC5E;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,yDAAyD;EACzD,oBAAoB;EACpB,wDAAwD;EACxD,iBAAiB;EACjB,sDAAsD;EACtD,mBAAmB;AACrB;;AAEA;EACE,uDAAuD;EACvD,mDAAmD;EACnD,+BAA+B;AACjC;;AAEA;EACE,oCAAoC;EACpC,mCAAmC;EACnC,gCAAgC;AAClC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,eAAe;EACf,kBAAkB;EAClB,yDAAyD;EACzD,oCAAoC;EACpC,qDAAqD;EACrD,mCAAmC;EACnC,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,6EAA6E;AAC/E;;AAEA;EACE,wDAAwD;EACxD,2BAA2B;EAC3B,mCAAmC;AACrC;;AAEA;EACE,yBAAyB;EACzB,wFAAwF;EACxF,WAAW;EACX,iEAAiE;AACnE;;AAEA;EACE,WAAW;EACX,qFAAqF;AACvF;;AAEA,4EAA4E;AAC5E;EACE,kBAAkB;EAClB,4BAA4B;EAC5B,yDAAyD;EACzD,mBAAmB;EACnB,wDAAwD;AAC1D;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,iBAAiB;EACjB,sDAAsD;AACxD;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,mDAAmD;EACnD,+BAA+B;EAC/B,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;;EAEE,gBAAgB;EAChB,kBAAkB;EAClB,qDAAqD;EACrD,wCAAwC;EACxC,iBAAiB;EACjB,+BAA+B;EAC/B,uBAAuB;AACzB;;AAEA,4EAA4E;AAC5E;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,gEAAgE;EAChE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,oCAAoC;EACpC,uBAAuB;EACvB,sDAAsD;EACtD,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,mDAAmD;AACrD;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,+BAA+B;EAC/B,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,yDAAyD;EACzD,mBAAmB;EACnB,mCAAmC;AACrC;;AAEA,4EAA4E;AAC5E;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,yDAAyD;EACzD,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,oDAAoD;EACpD,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,yDAAyD;EACzD,kBAAkB;EAClB,oCAAoC;EACpC,sDAAsD;EACtD,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,mCAAmC;EACnC,wDAAwD;AAC1D;;AAEA,4EAA4E;AAC5E;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,6DAA6D;EAC7D,iBAAiB;EACjB,kDAAkD;AACpD;;AAEA;EACE;IACE,mBAAmB;IACnB,iBAAiB;EACnB;;EAEA;IACE,SAAS;IACT,WAAW;EACb;AACF","sourcesContent":["/**\r\n * Página pública de descarga del agente CMDB (`/instalar-agente`).\r\n *\r\n * Prefijo `ad-` (Agent Download) para no colisionar con `login.css`, `lists.css`\r\n * ni los estilos de Bootstrap que se cargan globalmente. Solo se apoya en los\r\n * tokens del design system (colores, radios, tipografía).\r\n */\r\n\r\n.ad-page {\r\n  position: relative;\r\n  min-height: 100vh;\r\n  background: var(--slate-50, #07090f);\r\n  color: var(--text-primary, #e2e8f0);\r\n  font-family: var(--font-primary, 'Inter', sans-serif);\r\n  padding: 0 0 40px;\r\n  overflow-x: hidden;\r\n}\r\n\r\n.ad-glow {\r\n  position: fixed;\r\n  inset: 0;\r\n  z-index: 0;\r\n  pointer-events: none;\r\n  background:\r\n    radial-gradient(ellipse 70% 50% at 15% 0%, rgba(var(--accent-rgb, 99, 102, 241), .18) 0%, transparent 60%),\r\n    radial-gradient(ellipse 60% 45% at 85% 10%, rgba(139, 92, 246, .12) 0%, transparent 60%);\r\n}\r\n\r\n.ad-wrap {\r\n  position: relative;\r\n  z-index: 1;\r\n  max-width: 1080px;\r\n  margin: 0 auto;\r\n  padding: 0 20px;\r\n}\r\n\r\n/* ── Cabecera ─────────────────────────────────────────────────────────── */\r\n.ad-top {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  gap: 16px;\r\n  padding: 18px 0;\r\n}\r\n\r\n.ad-brand {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 10px;\r\n}\r\n\r\n.ad-brand-mark {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  width: 36px;\r\n  height: 36px;\r\n  border-radius: 10px;\r\n  color: #fff;\r\n  background: linear-gradient(135deg, var(--accent, #6366f1), var(--accent-2, #7c3aed));\r\n  box-shadow: 0 6px 18px rgba(var(--accent-rgb, 99, 102, 241), .35);\r\n}\r\n\r\n.ad-brand-name {\r\n  font-size: 1rem;\r\n  font-weight: 700;\r\n  letter-spacing: .01em;\r\n}\r\n\r\n.ad-brand-name em {\r\n  font-style: normal;\r\n  color: var(--accent-l, #818cf8);\r\n}\r\n\r\n.ad-link {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n  color: var(--text-secondary, rgba(255, 255, 255, .55));\r\n  font-size: .85rem;\r\n  text-decoration: none;\r\n  transition: color .15s ease;\r\n}\r\n\r\n.ad-link:hover {\r\n  color: var(--text-primary, #e2e8f0);\r\n}\r\n\r\n/* ── Hero ─────────────────────────────────────────────────────────────── */\r\n.ad-hero {\r\n  padding: 28px 0 8px;\r\n}\r\n\r\n.ad-h1 {\r\n  margin: 0 0 10px;\r\n  font-size: clamp(28px, 4vw, 42px);\r\n  font-weight: 700;\r\n  letter-spacing: -.02em;\r\n}\r\n\r\n.ad-sub {\r\n  margin: 0;\r\n  max-width: 720px;\r\n  font-size: .98rem;\r\n  line-height: 1.6;\r\n  color: var(--text-secondary, rgba(255, 255, 255, .55));\r\n}\r\n\r\n.ad-sub strong {\r\n  color: var(--text-primary, #e2e8f0);\r\n}\r\n\r\n.ad-hero-chips {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  gap: 8px;\r\n  margin-top: 16px;\r\n}\r\n\r\n.ad-alert {\r\n  margin-top: 16px;\r\n  padding: 10px 12px;\r\n  border: 1px solid rgba(245, 158, 11, .35);\r\n  border-radius: var(--radius-sm, 8px);\r\n  background: var(--amber-50, rgba(245, 158, 11, .15));\r\n  color: var(--text-primary, #e2e8f0);\r\n  font-size: .85rem;\r\n}\r\n\r\n/* ── Secciones ────────────────────────────────────────────────────────── */\r\n.ad-section {\r\n  margin-top: 40px;\r\n}\r\n\r\n.ad-h2 {\r\n  margin: 0 0 14px;\r\n  font-size: 1.15rem;\r\n  font-weight: 650;\r\n  letter-spacing: -.01em;\r\n}\r\n\r\n.ad-h3 {\r\n  margin: 20px 0 8px;\r\n  font-size: .95rem;\r\n  font-weight: 600;\r\n}\r\n\r\n.ad-p {\r\n  margin: 0 0 10px;\r\n  font-size: .88rem;\r\n  line-height: 1.6;\r\n  color: var(--text-secondary, rgba(255, 255, 255, .55));\r\n}\r\n\r\n.ad-p strong {\r\n  color: var(--text-primary, #e2e8f0);\r\n}\r\n\r\n/* ── Listas y tablas de instrucciones ─────────────────────────────────── */\r\n.ad-list {\r\n  margin: 0 0 12px;\r\n  padding-left: 20px;\r\n  font-size: .88rem;\r\n  line-height: 1.6;\r\n  color: var(--text-secondary, rgba(255, 255, 255, .55));\r\n}\r\n\r\n.ad-list li {\r\n  margin-bottom: 6px;\r\n}\r\n\r\n.ad-list li strong {\r\n  color: var(--text-primary, #e2e8f0);\r\n}\r\n\r\n.ad-table {\r\n  width: 100%;\r\n  margin: 6px 0 16px;\r\n  border-collapse: collapse;\r\n  font-size: .82rem;\r\n}\r\n\r\n.ad-table th,\r\n.ad-table td {\r\n  padding: 8px 10px;\r\n  border: 1px solid var(--border, rgba(255, 255, 255, .07));\r\n  text-align: left;\r\n  vertical-align: top;\r\n}\r\n\r\n.ad-table th {\r\n  background: var(--bg-toolbar, rgba(255, 255, 255, .025));\r\n  color: var(--text-primary, #e2e8f0);\r\n  font-weight: 600;\r\n}\r\n\r\n.ad-table td {\r\n  color: var(--text-secondary, rgba(255, 255, 255, .55));\r\n}\r\n\r\n.ad-table td:first-child {\r\n  font-family: var(--font-mono, monospace);\r\n  color: var(--accent-l, #818cf8);\r\n  white-space: nowrap;\r\n}\r\n\r\n/* Desplegables (Orca, CLI…) */\r\n.ad-details {\r\n  margin: 10px 0;\r\n  padding: 10px 12px;\r\n  border: 1px solid var(--border, rgba(255, 255, 255, .07));\r\n  border-radius: 10px;\r\n  background: var(--bg-toolbar, rgba(255, 255, 255, .025));\r\n}\r\n\r\n.ad-details summary {\r\n  cursor: pointer;\r\n  font-size: .85rem;\r\n  font-weight: 600;\r\n  color: var(--text-primary, #e2e8f0);\r\n}\r\n\r\n.ad-details[open] summary {\r\n  margin-bottom: 8px;\r\n}\r\n\r\n.ad-details .ad-list {\r\n  margin-bottom: 0;\r\n}\r\n\r\n/* Generador de scripts (todo en el navegador) */\r\n.ad-gen {\r\n  display: grid;\r\n  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));\r\n  gap: 12px;\r\n  margin: 12px 0 14px;\r\n}\r\n\r\n.ad-field {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 6px;\r\n  font-size: .82rem;\r\n  color: var(--text-secondary, rgba(255, 255, 255, .55));\r\n}\r\n\r\n.ad-field input,\r\n.ad-field select {\r\n  width: 100%;\r\n  padding: 9px 10px;\r\n  border: 1px solid var(--border, rgba(255, 255, 255, .07));\r\n  border-radius: var(--radius-sm, 8px);\r\n  background: var(--bg-input, rgba(255, 255, 255, .05));\r\n  color: var(--text-primary, #e2e8f0);\r\n  font-family: inherit;\r\n  font-size: .85rem;\r\n}\r\n\r\n.ad-field input:focus,\r\n.ad-field select:focus {\r\n  outline: none;\r\n  border-color: rgba(var(--accent-rgb, 99, 102, 241), .55);\r\n  box-shadow: 0 0 0 3px rgba(var(--accent-rgb, 99, 102, 241), .15);\r\n}\r\n\r\n.ad-field .ad-hint {\r\n  margin: 0;\r\n}\r\n\r\n.ad-gen-actions {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  gap: 10px;\r\n  margin-bottom: 14px;\r\n}\r\n\r\n.ad-gen-actions .ad-btn {\r\n  margin-top: 0;\r\n}\r\n\r\n/* Aviso de credencial en el MST */\r\n.ad-warn {\r\n  margin-top: 14px;\r\n  padding: 10px 12px;\r\n  border: 1px solid rgba(245, 158, 11, .4);\r\n  border-radius: 10px;\r\n  background: var(--amber-50, rgba(245, 158, 11, .15));\r\n  font-size: .82rem;\r\n  line-height: 1.55;\r\n  color: var(--text-primary, #e2e8f0);\r\n}\r\n\r\n.ad-warn strong {\r\n  color: var(--amber-600, #f59e0b);\r\n}\r\n\r\n.ad-hint {\r\n  margin: 8px 0 0;\r\n  font-size: .76rem;\r\n  line-height: 1.5;\r\n  color: var(--text-muted, rgba(255, 255, 255, .35));\r\n}\r\n\r\n/* ── Rejillas y tarjetas ──────────────────────────────────────────────── */\r\n.ad-grid {\r\n  display: grid;\r\n  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));\r\n  gap: 16px;\r\n}\r\n\r\n.ad-grid--3 {\r\n  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));\r\n}\r\n\r\n.ad-card {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 8px;\r\n  padding: 18px;\r\n  border: 1px solid var(--border, rgba(255, 255, 255, .07));\r\n  border-radius: 14px;\r\n  background: var(--bg-card, #0d0f1a);\r\n  box-shadow: 0 10px 30px rgba(0, 0, 0, .25);\r\n}\r\n\r\n.ad-card--primary {\r\n  border-color: rgba(var(--accent-rgb, 99, 102, 241), .45);\r\n  box-shadow: 0 10px 34px rgba(var(--accent-rgb, 99, 102, 241), .18);\r\n}\r\n\r\n.ad-card-head {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  gap: 8px;\r\n}\r\n\r\n.ad-card-title {\r\n  margin: 0;\r\n  font-size: 1rem;\r\n  font-weight: 650;\r\n}\r\n\r\n.ad-card-sub {\r\n  margin: 0;\r\n  font-size: .8rem;\r\n  color: var(--text-secondary, rgba(255, 255, 255, .55));\r\n}\r\n\r\n.ad-meta {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  align-items: center;\r\n  gap: 8px;\r\n  font-size: .78rem;\r\n  color: var(--text-secondary, rgba(255, 255, 255, .55));\r\n}\r\n\r\n.ad-filename {\r\n  font-family: var(--font-mono, monospace);\r\n  font-size: .78rem;\r\n  color: var(--text-primary, #e2e8f0);\r\n  overflow-wrap: anywhere;\r\n}\r\n\r\n.ad-note {\r\n  margin: 0;\r\n  font-size: .8rem;\r\n  color: var(--text-secondary, rgba(255, 255, 255, .55));\r\n}\r\n\r\n.ad-hash {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 2px;\r\n  font-size: .7rem;\r\n  color: var(--text-muted, rgba(255, 255, 255, .35));\r\n}\r\n\r\n.ad-hash code {\r\n  font-family: var(--font-mono, monospace);\r\n  font-size: .7rem;\r\n  color: var(--text-secondary, rgba(255, 255, 255, .55));\r\n  overflow-wrap: anywhere;\r\n}\r\n\r\n.ad-empty p {\r\n  margin: 0 0 4px;\r\n  font-size: .85rem;\r\n  color: var(--text-secondary, rgba(255, 255, 255, .55));\r\n}\r\n\r\n/* ── Chips y botones ──────────────────────────────────────────────────── */\r\n.ad-chip {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 5px;\r\n  padding: 3px 9px;\r\n  border: 1px solid var(--border, rgba(255, 255, 255, .07));\r\n  border-radius: 999px;\r\n  background: var(--bg-toolbar, rgba(255, 255, 255, .025));\r\n  font-size: .74rem;\r\n  color: var(--text-secondary, rgba(255, 255, 255, .55));\r\n  white-space: nowrap;\r\n}\r\n\r\n.ad-chip--accent {\r\n  border-color: rgba(var(--accent-rgb, 99, 102, 241), .5);\r\n  background: var(--blue-50, rgba(99, 102, 241, .15));\r\n  color: var(--accent-l, #818cf8);\r\n}\r\n\r\n.ad-chip--on {\r\n  border-color: rgba(16, 185, 129, .4);\r\n  background: rgba(16, 185, 129, .12);\r\n  color: var(--green-600, #10b981);\r\n}\r\n\r\n.ad-btn {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: 8px;\r\n  margin-top: 6px;\r\n  padding: 10px 14px;\r\n  border: 1px solid var(--border, rgba(255, 255, 255, .07));\r\n  border-radius: var(--radius-sm, 8px);\r\n  background: var(--bg-input, rgba(255, 255, 255, .05));\r\n  color: var(--text-primary, #e2e8f0);\r\n  font-size: .85rem;\r\n  font-weight: 600;\r\n  text-decoration: none;\r\n  transition: border-color .15s ease, transform .15s ease, background .15s ease;\r\n}\r\n\r\n.ad-btn:hover {\r\n  border-color: var(--slate-300, rgba(255, 255, 255, .14));\r\n  transform: translateY(-1px);\r\n  color: var(--text-primary, #e2e8f0);\r\n}\r\n\r\n.ad-btn--primary {\r\n  border-color: transparent;\r\n  background: linear-gradient(135deg, var(--accent, #6366f1), var(--accent-dark, #4f46e5));\r\n  color: #fff;\r\n  box-shadow: 0 8px 22px rgba(var(--accent-rgb, 99, 102, 241), .35);\r\n}\r\n\r\n.ad-btn--primary:hover {\r\n  color: #fff;\r\n  background: linear-gradient(135deg, var(--accent-l, #818cf8), var(--accent, #6366f1));\r\n}\r\n\r\n/* ── Pasos previos ────────────────────────────────────────────────────── */\r\n.ad-step {\r\n  position: relative;\r\n  padding: 16px 16px 16px 18px;\r\n  border: 1px solid var(--border, rgba(255, 255, 255, .07));\r\n  border-radius: 12px;\r\n  background: var(--bg-toolbar, rgba(255, 255, 255, .025));\r\n}\r\n\r\n.ad-step h3 {\r\n  margin: 0 0 6px;\r\n  font-size: .92rem;\r\n  font-weight: 650;\r\n}\r\n\r\n.ad-step p {\r\n  margin: 0;\r\n  font-size: .84rem;\r\n  line-height: 1.55;\r\n  color: var(--text-secondary, rgba(255, 255, 255, .55));\r\n}\r\n\r\n.ad-step-num {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  width: 24px;\r\n  height: 24px;\r\n  margin-bottom: 8px;\r\n  border-radius: 50%;\r\n  background: var(--blue-50, rgba(99, 102, 241, .15));\r\n  color: var(--accent-l, #818cf8);\r\n  font-size: .78rem;\r\n  font-weight: 700;\r\n}\r\n\r\n.ad-role {\r\n  display: block;\r\n  margin-top: 6px;\r\n}\r\n\r\n.ad-role code,\r\n.ad-inline-code {\r\n  padding: 1px 5px;\r\n  border-radius: 4px;\r\n  background: var(--bg-input, rgba(255, 255, 255, .05));\r\n  font-family: var(--font-mono, monospace);\r\n  font-size: .78rem;\r\n  color: var(--accent-l, #818cf8);\r\n  overflow-wrap: anywhere;\r\n}\r\n\r\n/* ── Pestañas de instalación ──────────────────────────────────────────── */\r\n.ad-tabs {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  gap: 4px;\r\n  border-bottom: 1px solid var(--border, rgba(255, 255, 255, .07));\r\n  margin-bottom: 16px;\r\n}\r\n\r\n.ad-tab {\r\n  padding: 9px 14px;\r\n  border: none;\r\n  border-bottom: 2px solid transparent;\r\n  background: transparent;\r\n  color: var(--text-secondary, rgba(255, 255, 255, .55));\r\n  font-size: .85rem;\r\n  font-weight: 550;\r\n  cursor: pointer;\r\n  transition: color .15s ease, border-color .15s ease;\r\n}\r\n\r\n.ad-tab:hover {\r\n  color: var(--text-primary, #e2e8f0);\r\n}\r\n\r\n.ad-tab.is-active {\r\n  color: var(--accent-l, #818cf8);\r\n  border-bottom-color: var(--accent, #6366f1);\r\n}\r\n\r\n.ad-panel {\r\n  padding: 18px;\r\n  border: 1px solid var(--border, rgba(255, 255, 255, .07));\r\n  border-radius: 12px;\r\n  background: var(--bg-card, #0d0f1a);\r\n}\r\n\r\n/* ── Bloques de código ────────────────────────────────────────────────── */\r\n.ad-code-wrap {\r\n  position: relative;\r\n  margin: 10px 0 14px;\r\n}\r\n\r\n.ad-code {\r\n  margin: 0;\r\n  padding: 14px 14px;\r\n  padding-right: 90px;\r\n  border: 1px solid var(--border, rgba(255, 255, 255, .07));\r\n  border-radius: 10px;\r\n  background: #06070c;\r\n  color: #d7dcf5;\r\n  font-family: var(--font-mono, 'Consolas', monospace);\r\n  font-size: .79rem;\r\n  line-height: 1.6;\r\n  overflow-x: auto;\r\n  white-space: pre;\r\n  tab-size: 2;\r\n}\r\n\r\n.ad-copy {\r\n  position: absolute;\r\n  top: 8px;\r\n  right: 8px;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 5px;\r\n  padding: 4px 8px;\r\n  border: 1px solid var(--border, rgba(255, 255, 255, .07));\r\n  border-radius: 6px;\r\n  background: rgba(255, 255, 255, .04);\r\n  color: var(--text-secondary, rgba(255, 255, 255, .55));\r\n  font-size: .72rem;\r\n  cursor: pointer;\r\n}\r\n\r\n.ad-copy:hover {\r\n  color: var(--text-primary, #e2e8f0);\r\n  border-color: var(--slate-300, rgba(255, 255, 255, .14));\r\n}\r\n\r\n/* ── Pie ──────────────────────────────────────────────────────────────── */\r\n.ad-foot {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  gap: 12px;\r\n  flex-wrap: wrap;\r\n  margin-top: 48px;\r\n  padding-top: 18px;\r\n  border-top: 1px solid var(--border, rgba(255, 255, 255, .07));\r\n  font-size: .78rem;\r\n  color: var(--text-muted, rgba(255, 255, 255, .35));\r\n}\r\n\r\n@media (max-width: 640px) {\r\n  .ad-code {\r\n    padding-right: 14px;\r\n    padding-top: 40px;\r\n  }\r\n\r\n  .ad-copy {\r\n    left: 8px;\r\n    right: auto;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
